import React from 'react'
import { Modal, ModalBody } from 'uiComponents/popups/modal.new'
import './cancelMembershipModal.scss'
import { MembershipDetailed } from 'memberships/schema'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import ActionButton from 'uiComponents/buttons'
import 'uiComponents/buttons/styles/cancelButton.scss'
import { DateFormats, formatISOString } from 'utils'
import { useTranslation } from 'translations'

interface CancelMembershipModalProps {
    membership: MembershipDetailed
    onCancelMembership: () => void
    onDisableAutoRenewal: () => void
    onClose: () => void
}

export const CancelMembershipModal: React.FC<CancelMembershipModalProps> = ({
    membership,
    onCancelMembership,
    onDisableAutoRenewal,
    onClose,
}) => {
    const { t } = useTranslation()
    const title = membership.autoRenewEnabled
        ? t('memberships.membershipDetailsPanel.cancelMembershipModal.titleWithAutoRenew')
        : t('memberships.membershipDetailsPanel.cancelMembershipModal.title')
    const expiresAtString = formatISOString(membership.expiresAt, DateFormats.EXTRA_LONG_DATE)

    const handleCancelMembership = async () => {
        await onCancelMembership()
        onClose()
    }

    const handleDisableAutoRenewal = async () => {
        await onDisableAutoRenewal()
        onClose()
    }

    return (
        <Modal className="cancel-membership-modal" title={title} onDismiss={onClose}>
            <ModalBody>
                {membership.autoRenewEnabled && (
                    <div className="option disable-auto-renew">
                        <div className="option-title">{t('memberships.membershipDetailsPanel.cancelMembershipModal.disableAutoRenew')}</div>
                        <ul>
                            <li>{t('memberships.membershipDetailsPanel.cancelMembershipModal.willExpireOn', { date: expiresAtString })}</li>
                            <li>
                                {membership.billing.paymentSchedule === 'P1M'
                                    ? t('memberships.membershipDetailsPanel.cancelMembershipModal.monthlyPaymentsContinue')
                                    : t('memberships.membershipDetailsPanel.cancelMembershipModal.noOutstandingPayments')}
                            </li>
                            <li>
                                {membership.member?.firstName != null
                                    ? t('memberships.membershipDetailsPanel.cancelMembershipModal.canVisitUntilExpiry', {
                                          name: membership.member.firstName,
                                      })
                                    : t('memberships.membershipDetailsPanel.cancelMembershipModal.memberCanVisitUntilExpiry')}
                            </li>
                        </ul>
                        <ActionButton className="cancel-button" onClick={handleDisableAutoRenewal}>
                            {t('memberships.membershipDetailsPanel.cancelMembershipModal.disableAutoRenew')}
                        </ActionButton>
                    </div>
                )}
                <div className="option cancel-membership">
                    <div className="option-title">{t('memberships.membershipDetailsPanel.cancelMembershipModal.endImmediately')}</div>
                    <ul>
                        <li>{t('memberships.membershipDetailsPanel.cancelMembershipModal.accessEndsImmediately')}</li>
                        <li>{t('memberships.membershipDetailsPanel.cancelMembershipModal.paymentsWaived')}</li>
                        <li>
                            {membership.member?.firstName != null
                                ? t('memberships.membershipDetailsPanel.cancelMembershipModal.noLongerVisit', {
                                      name: membership.member.firstName,
                                  })
                                : t('memberships.membershipDetailsPanel.cancelMembershipModal.memberNoLongerVisit')}
                        </li>
                    </ul>
                    <PressAndHoldButton
                        text={t('memberships.membershipDetailsPanel.cancelMembershipModal.endImmediately')}
                        holdTime={3000}
                        onComplete={handleCancelMembership}
                        destructive
                    />
                </div>
            </ModalBody>
        </Modal>
    )
}
